import data from './nimLang_cht.json';
const LocaleConfig = {
    ...data,
    "AllRight": "[好吧]",
    "Ambulance": "[救護車]",
    "Angle": "[天使]",
    "Angry": "[生氣]",
    "Applause": "[鼓掌]",
    "Awkward": "[尷尬]",
    "Beckoning": "[心動]",
    "Bomb": "[炸彈]",
    "Broken": "[心碎]",
    "Bye": "[拜拜]",
    "Cloud": "[筋斗雲]",
    "Cool": "[酷]",
    "Cry": "[大哭]",
    "Cute": "[可愛]",
    "Despise": "[鄙視]",
    "Disdain": "[不屑]",
    "Ecstasy": "[狂喜]",
    "First": "[第一]",
    "Fist": "[拳頭]",
    "Fretting": "[煩躁]",
    "Frown": "[皺眉]",
    "Funny": "[笑哭]",
    "Ghost": "[鬼怪]",
    "GiveMeFive": "[手掌]",
    "GoodJob": "[給力]",
    "Grimace": "[鬼臉]",
    "Halo": "[兩眼冒星]",
    "Happy": "[開心]",
    "Hi": "[招手]",
    "Hit": "[打你]",
    "Hold": "[舉著]",
    "Joy": "[喜悅]",
    "Kiss": "[親]",
    "Knife": "[剪刀]",
    "Laugh": "[大笑]",
    "Low": "[低級]",
    "Mad": "[憤怒]",
    "Mask": "[口罩]",
    "Mischievous": "[奸笑]",
    "Monkey": "[猴子]",
    "Nice": "[贊]",
    "No": "[不要]",
    "NoListen": "[不聽]",
    "NoLook": "[不看]",
    "NoWords": "[不說]",
    "Ok": "[好的]",
    "Pig": "[豬頭]",
    "Please": "[阿彌陀佛]",
    "Poop": "[便便]",
    "Rocket": "[火箭]",
    "Sexy": "[色]",
    "Shame": "[害羞]",
    "Sleep": "[睡著]",
    "Sleeping": "[睡覺]",
    "Snicker": "[偷笑]",
    "Spit": "[伸舌頭]",
    "Squint": "[眯眼]",
    "Surprise": "[驚訝]",
    "Sweat": "[流汗]",
    "Tears": "[流淚]",
    "Terrorist": "[恐怖]",
    "Think": "[思考]",
    "Thrill": "[驚恐]",
    "Tired": "[冒星]",
    "Uncomfortable": "[難受]",
    "Unhappy": "[不高興]",
    "acceptFailedText": "同意該申請失敗",
    "acceptResultText": "已同意",
    "acceptText": "同意",
    "acceptedText": "已同意",
    "accountNotMatchText": "查無此帳號",
    "accountPlaceholder": "請輸入帳號",
    "accountText": "帳號",
    "addButtonText": "添加",
    "addChatMemberText": "添加聊天成員",
    "addFailedText": "添加失敗",
    "addFriendFailedText": "添加好友失敗",
    "addFriendMode": "添加好友模式",
    "addFriendSuccessText": "添加好友成功",
    "addFriendText": "添加好友",
    "addMessageTop": "置頂了一條消息",
    "addStickTopText": "置頂消息",
    "addSuccessText": "添加成功",
    "addTeamMemberConfirmText": "請選擇要添加的群成員",
    "addTeamMemberFailedText": "添加成員失敗",
    "addTeamMemberSuccessText": "添加成員成功",
    "addTeamMemberText": "添加成員",
    "addTeamMemberVerifyText": "等待驗證中",
    "addressText": "通訊錄",
    "aiAntiSpamText": "AI請求命中反垃圾",
    "aiBlockFailedText": "不允許對數字人進行黑名單操作",
    "aiConversationSelectFailed": "選擇AI會話失敗",
    "aiErrorText": "服務器繁忙，請稍後再試",
    "aiFriendNotExists": "好友不存在",
    "aiFunctionDisabled": "AI消息功能未開通",
    "aiListTitle": "我的數字人",
    "aiMemberBanned": "用戶被禁用",
    "aiMemberChatBanned": "用戶被禁言",
    "aiMenuText": "我的數字人",
    "aiMessageHitAntiSpam": "消息命中反垃圾",
    "aiNormalTeamChatBanned": "群普通成員禁言",
    "aiParameterError": "參數錯誤",
    "aiProxyFailedText": "模型請求异常",
    "aiRateLimit": "頻率超限",
    "aiSearchInputPlaceholder": "補充輸入更多資訊",
    "aiSearchText": "AI劃詞搜",
    "aiSearchingText": "AI劃詞搜索中. ..",
    "aiSendingText": "大模型請求響應中",
    "aiStopFailedText": "停止輸出失敗",
    "aiStreamCancelText": "請求已取消",
    "aiStreamText": "數字人流式輸出",
    "aiTeamChatBanned": "群成員被禁言",
    "aiTeamMemberNotExists": "群成員不存在",
    "aiTranslateEmptyText": "請輸入需要翻譯的內容",
    "aiTranslatePlaceholder": "翻譯為. ..",
    "aiTranslateText": "AI處理",
    "aiTranslatedText": "使用",
    "aiTranslatingText": "AI處理中. ..",
    "aiUserText": "數字人",
    "aleadyInTeamText": "已在群組",
    "aliasText": "備註",
    "allReadText": "全部已讀",
    "allUnReadText": "全部未讀",
    "amap": "高德地圖",
    "applyFriendFailedText": "申請添加好友失敗",
    "applyFriendSuccessText": "申請添加好友成功",
    "applyFriendText": "添加您為好友",
    "applyTeamSuccessText": "申請入群成功",
    "applyTeamText": "申請入群",
    "audioMsgText": "音訊消息",
    "bdmap": "百度地圖",
    "beAddTeamManagersText": "被任命為管理員",
    "beMentioned": "[有人@我]",
    "beRejectResultText": "拒絕了好友申請",
    "beRemoveTeamManagersText": "被移除管理員",
    "beRemoveTeamText": "被移出群組",
    "blackFailedText": "拉黑失敗",
    "blackListDesc": "（你不會收到清單中任何連絡人的消息）",
    "blackListTitle": "黑名單",
    "blackMenuText": "黑名單",
    "blackSuccessText": "拉黑成功",
    "blackText": "拉黑好友",
    "callBusyText": "對方忙",
    "callCancelText": "已取消",
    "callDurationText": "通話時長",
    "callFailed": "呼叫失敗",
    "callMsgText": "話單消息",
    "callRejectedText": "已拒絕",
    "callTimeoutText": "已超時",
    "cancelText": "取消",
    "cancelUploadFailedText": "取消上傳失敗",
    "chatButtonText": "去聊天",
    "chatHistoryText": "聊天記錄",
    "closeAgreeModeText": "關閉了入群邀請需要同意",
    "closeApplyModeText": "關閉了入群稽核",
    "closeText": "關閉",
    "collection": "收藏",
    "collectionFailed": "收藏失敗",
    "collectionSuccess": "已收藏",
    "collectionText": "收藏",
    "commentText": "留言",
    "confirmDeleteFriendText": "確定删除好友？",
    "confirmDeleteText": "確定删除？",
    "confirmRemoveCollection": "確認删除收藏？",
    "createButtonText": "創建",
    "createDiscussionText": "創建討論群組",
    "createTeamFailedText": "創建群組失敗",
    "createTeamMemberLimitText": "群人數上限",
    "createTeamSuccessText": "創建群組成功",
    "createTeamText": "創建群組",
    "customMsgText": "自定義消息",
    "deleteFriendFailedText": "删除好友失敗",
    "deleteFriendSuccessText": "删除好友成功",
    "deleteFriendText": "删除好友",
    "deleteSessionText": "删除會話",
    "deleteStickTopText": "取消置頂",
    "deleteText": "删除",
    "discussionAvatarText": "討論群組頭像",
    "discussionDoNotDisturbText": "討論群組免打擾",
    "discussionIdText": "討論群組ID",
    "discussionMemberText": "討論群組成員",
    "discussionText": "討論群組資料",
    "discussionTitle": "討論群組名稱",
    "dismissTeamConfirmText": "是否確認解散該群組",
    "dismissTeamFailedText": "群解散失敗",
    "dismissTeamSuccessText": "群解散成功",
    "dismissTeamText": "解散群組",
    "editNickInTeamText": "編輯我在群裏的昵稱",
    "emailErrorText": "郵箱格式不正確",
    "emailPlaceholder": "請輸入郵箱",
    "emailText": "郵箱",
    "enText": "English",
    "enableV2CloudConversationText": "是否開啟雲端會話",
    "enterTeamText": "進入了群組",
    "expiredResultText": "已過期",
    "fileMsgText": "檔案消息",
    "forwardFailedText": "轉發失敗",
    "forwardSuccessText": "轉發成功",
    "forwardText": "轉發",
    "friendListTitle": "我的好友",
    "friendMenuText": "我的好友",
    "friendText": "好友",
    "genderPlaceholder": "請選擇性別",
    "genderText": "性別",
    "geoMsgShortText": "位置",
    "geoMsgText": "地理位置消息",
    "getApplyMsgFailedText": "獲取消息失敗",
    "getCollectionFailed": "査詢收藏清單失敗",
    "getHistoryMsgFailedText": "獲取歷史消息失敗",
    "getRelationFailedText": "獲取關係失敗",
    "huff": "[發怒]",
    "ill": "[不舒服]",
    "imgMsgText": "圖片消息",
    "imgText": "圖片",
    "inCallText": "已在通話中，請結束通話後再呼叫",
    "inviteTeamText": "邀請您加入",
    "inviteText": "邀請",
    "joinTeamFailedText": "加入群組失敗",
    "joinTeamSuccessText": "加入群組成功",
    "joinTeamText": "加入群組",
    "joinTeamWithVerifyText": "入群申請已發送",
    "languageText": "語言",
    "leaveDiscussionButtonText": "退出討論群組",
    "leaveDiscussionConfirmText": "是否確認退出該討論群組",
    "leaveDiscussionFailedText": "退出此討論群組失敗",
    "leaveDiscussionSuccessText": "已成功退出此討論群組",
    "leaveDiscussionText": "離開了討論群組",
    "leaveDiscussionTitle": "退出討論群組",
    "leaveTeamButtonText": "删除並退出",
    "leaveTeamConfirmText": "是否確認退出該群組",
    "leaveTeamFailedText": "退出此群失敗",
    "leaveTeamSuccessText": "已成功退出此群",
    "leaveTeamText": "離開了群組",
    "leaveTeamTitle": "離開群組",
    "logoutConfirmText": "確定登出嗎？",
    "logoutText": "登出",
    "man": "男",
    "maxSelectedText": "最多只能選擇",
    "memberNotExistsText": "用戶不存在",
    "msgListTitle": "消息中心",
    "msgMenuText": "消息中心",
    "msgRecallTimeErrorText": "已超過時間無法撤回",
    "muteAllTeamFailedText": "開啟全員禁言失敗",
    "muteAllTeamSuccessText": "開啟全員禁言成功",
    "muteSessionText": "開啟免打擾",
    "needBeInvitedText": "需要被邀請人同意",
    "needMentionText": "是否需要@消息",
    "needVerifyText": "需要驗證",
    "networkDisconnectText": "網絡連接已斷開，請檢查您的網絡設定並嘗試重新連接",
    "newGroupOwnerText": "成為新群主",
    "nickInTeamText": "我在群裏的昵稱",
    "nickPlaceholder": "請輸入昵稱",
    "nickText": "昵稱",
    "noMoreCollectionText": "已滑到最底部~",
    "noMoreText": "沒有更多消息了",
    "noPermission": "您暫無許可權操作",
    "noText": "否",
    "notAnAi": "不是數字人帳號",
    "notNeedBeInvitedText": "不需要被邀請人同意",
    "notNeedVerifyText": "不需要驗證",
    "notSupportJoinText": "討論群組無法直接加入，請聯系管理員拉您入群",
    "notSupportMessageText": "暫不支持該消息",
    "notiMsgText": "通知消息",
    "offlineText": "（離線）",
    "ok": "[OK]",
    "okText": "確定",
    "onDismissDiscussionText": "討論群組已被解散",
    "onDismissTeamText": "群已被解散",
    "onRemoveTeamText": "您已被移出群組",
    "onlineText": "（線上）",
    "onlyTeamOwner": "僅群主",
    "openAgreeModeText": "開啟了入群邀請需要同意",
    "openApplyModeText": "開啟了入群稽核",
    "openText": "開啟",
    "oppositeSide": "對方",
    "p2pMsgVisibleModeText": "是否顯示p2p消息已讀未讀",
    "passFriendAskText": "我已經同意了你的申請，現在開始聊天吧~",
    "passResultText": "通過了好友申請",
    "personUnit": "人",
    "phonePlaceholder": "請輸入手機號",
    "phoneText": "手機",
    "pinAIText": "PIN置頂",
    "processedValidationMessageText": "該驗證消息已被處理",
    "readText": "已讀",
    "recallMessageText": "撤回了一條消息",
    "recallReplyMessageText": "該消息已撤回或删除",
    "recallText": "撤回",
    "receiveText": "您收到了新消息",
    "recentConversationText": "最近會話",
    "recentForwardText": "最近轉發",
    "recentSessionText": "最近訪問",
    "reeditText": "重新編輯",
    "regenAIMsgFailedText": "重新生成失敗",
    "rejectFailedText": "拒絕該申請失敗",
    "rejectResultText": "已拒絕",
    "rejectTeamFailedText": "拒絕群申請失敗",
    "rejectTeamInviteText": "拒絕了群邀請",
    "rejectText": "拒絕",
    "rejectedTeamText": "已拒絕群申請",
    "rejectedText": "已拒絕該申請",
    "removeBlackFailedText": "解除拉黑失敗",
    "removeBlackSuccessText": "解除拉黑成功",
    "removeBlackText": "解除拉黑",
    "removeCollectionFailed": "删除收藏失敗",
    "removeCollectionSuccess": "删除收藏成功",
    "removeMessageTop": "移除了置頂消息",
    "removeTeamMemberConfirmText": "是否確認移除該成員？",
    "removeTeamMemberFailedText": "移除成員失敗",
    "removeTeamMemberSuccessText": "移除成員成功",
    "removeTeamMemberText": "移除成員",
    "replyText": "回復",
    "robotMsgText": "機器消息",
    "saveFailedText": "保存失敗",
    "saveSuccessText": "保存成功",
    "saveText": "保存",
    "sdkVersionSelectionText": "sdk版本選擇",
    "searchButtonText": "查找",
    "searchDiscussionMemberPlaceholder": "蒐索討論群組成員",
    "searchDiscussionTitle": "討論群組",
    "searchEmptyText": "您暫未添加好友和群組",
    "searchFriendTitle": "好友",
    "searchInputPlaceholder": "蒐索",
    "searchNoResText": "暫無搜索結果",
    "searchTeamMemberPlaceholder": "蒐索群成員",
    "searchTeamPlaceholder": "請輸入群名稱",
    "searchTeamTitle": "群組",
    "searchText": "蒐索",
    "searchTipText": "Enter蒐索",
    "securityTipText": "僅用於體驗雲信IM產品功能，請勿輕信匯款、中獎等涉及錢款的資訊，勿輕易撥打陌生電話，謹防上當受騙。",
    "selectedText": "已選",
    "sendBlackFailedText": "您已被對方拉入黑名單",
    "sendBtnText": "發送",
    "sendEmptyText": "不能發送空白消息",
    "sendMsgFailedText": "消息發送失敗",
    "sendNotFriendFailedText": "當前非好友關係",
    "sendText": "發送消息",
    "sendToText": "發送給",
    "sendUsageText": "（按enter直接發送，shift+enter換行）",
    "session": "會話",
    "setText": "設定",
    "settingText": "設定",
    "signPlaceholder": "請輸入簽名",
    "signText": "簽名",
    "strangerNotiText": "當前不是您的好友，請注意保護個人隱私安全。",
    "strangerText": "比特陌生人",
    "teamAgreeModeExplainText": "開啟後，成員入群時需要群主或管理同意",
    "teamAgreeModeText": "入群稽核",
    "teamAll": "所有人",
    "teamAtModeText": "誰可以@所有人",
    "teamAvatarConfirmText": "群頭像不能為空",
    "teamAvatarText": "群頭像",
    "teamDoNotDisturbText": "群免打擾",
    "teamIdNotMatchText": "查無此群號",
    "teamIdPlaceholder": "請輸入群組ID",
    "teamIdText": "群ID",
    "teamInfoText": "群資料",
    "teamInviteModeText": "誰可以邀請新成員",
    "teamJoinModeExplainText": "開啟後，拉入入群，需被邀請人同意",
    "teamJoinModeFreeText": "自由加入，無須驗證",
    "teamJoinModeNeedVerifyText": "需申請，群主或管理同意後加入",
    "teamJoinModeText": "入群邀請需同意",
    "teamListTitle": "我的群組",
    "teamManagerEditText": "人員管理",
    "teamManagerEmptyText": "暫無群管理人員",
    "teamManagerEnableText": "是否開啟群管理員功能",
    "teamManagerLimitText": "誰可以修改資料",
    "teamManagerText": "群管理員",
    "teamMemberLimitText": "群成員數量已達上限",
    "teamMemberNotExist": "該群聊已不存在",
    "teamMemberText": "群成員",
    "teamMenuText": "我的群組",
    "teamMsgVisibleModeText": "是否顯示群消息已讀未讀",
    "teamMutePlaceholder": "當前群聊禁言中",
    "teamMuteText": "群禁言",
    "teamNotExitsText": "群組不存在",
    "teamOwnerAndManagerText": "群主和管理員",
    "teamOwnerText": "群主",
    "teamPowerText": "群管理",
    "teamSignPlaceholder": "請輸入內容",
    "teamSignText": "群介紹",
    "teamTitle": "群名稱",
    "teamTitleConfirmText": "群名稱不能為空",
    "teamTitlePlaceholder": "請輸入群名稱",
    "teamTopModeText": "誰可以置頂消息",
    "textMsgText": "文字消息",
    "tipAIFailedMessageText": "請求大語言模型失敗",
    "tipAIMessageText": "格式不支持",
    "tipMsgText": "提示消息",
    "topFailedText": "置頂失敗",
    "topText": "置頂",
    "transferOwnerConfirmText": "是否確認轉讓群主",
    "transferOwnerText": "轉讓群主",
    "transferTeamFailedText": "轉讓群主失敗",
    "transferTeamSuccessText": "轉讓群主成功",
    "transferToText": "轉讓給",
    "txmap": "騰訊地圖",
    "unTopText": "取消置頂",
    "unknow": "未知",
    "unknowMsgText": "未知消息",
    "unmuteAllTeamFailedText": "結束全員禁言失敗",
    "unmuteAllTeamSuccessText": "結束全員禁言成功",
    "unmuteSessionText": "取消免打擾",
    "unreadText": "未讀",
    "updateAliasFailedText": "修改備註失敗",
    "updateAliasSuccessText": "修改備註成功",
    "updateAllowAt": "更新了“@所有人許可權”為",
    "updateAllowTop": "置頂消息許可權更新為",
    "updateBitConfigMaskFailed": "更新群消息免打擾失敗",
    "updateBitConfigMaskSuccess": "更新群消息免打擾成功",
    "updateMyMemberNickFailed": "更新我的群昵稱失敗",
    "updateMyMemberNickSuccess": "更新我的群昵稱成功",
    "updateTeamAvatar": "更新了群頭像",
    "updateTeamFailedText": "修改失敗",
    "updateTeamIntro": "更新了群介紹",
    "updateTeamInviteMode": "更新了群許可權“邀請他人許可權”為",
    "updateTeamManagerFailText": "修改群管理員失敗",
    "updateTeamManagerSuccessText": "修改群管理員成功",
    "updateTeamMute": "更新了“群禁言”為",
    "updateTeamName": "更新群名稱為",
    "updateTeamSuccessText": "修改成功",
    "updateTeamUpdateTeamMode": "更新了群許可權“群資料修改許可權”為",
    "uploadImgFailedText": "上傳圖片失敗",
    "uploadLimitText": "圖片視頻或文件大小最大支持",
    "uploadLimitUnit": "M",
    "userNotInTeam": "成員已不在群中",
    "vedioCallText": "視頻通話",
    "verifyMsgNotExitsText": "該驗證消息已被處理",
    "videoMsgText": "視頻消息",
    "videoText": "視頻",
    "voiceCallText": "語音通話",
    "voiceToText": "語音轉文字",
    "voiceToTextFailedText": "轉文字失敗",
    "welcomeText": "歡迎使用雲信",
    "woman": "女",
    "yesText": "是",
    "you": "你",
    "zhText": "中文",
    zh: '中文',
    en: '英語',
    jp: '日語',
    kor: '韩語',
    fra: '法語',
    ara: '阿拉伯語',
    ru: '俄語',
    vie: '越南語',
}

export default LocaleConfig